<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section >
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="phone">
                                                {{ $t('label.user_id') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="user_id"
                                                name="user_id"
                                                id="user_id"
                                                v-model="query.user_id"
                                                dir="ltr"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="full_name">
                                                {{ $t('label.full_name') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="full_name"
                                                name="full_name"
                                                id="full_name"
                                                v-model="query.full_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="gateway_title">
                                                {{ $t('label.gateway_title') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="fa_gateway_name"
                                                name="fa_gateway_name"
                                                id="fa_gateway_name"
                                                v-model="query.fa_gateway_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="username">
                                                {{ $t('label.username') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="username"
                                                    name="username"
                                                    dir="ltr"
                                                    id="username"
                                                    v-model="query.username"
                                                />

                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group
                                        >
                                            <kt-form-label>
                                                {{ $t('label.wage_type') }}
                                            </kt-form-label>
                                            <kt-form-select size="3" id="wage_type" v-model="query.wage_plan" name="wage_type">
                                                <option
                                                    v-bind:key="index"
                                                    v-for="(wage_type, index) in wage_types"
                                                    v-bind:value="wage_type.value"
                                                    :selected="wage_type.value"
                                                >
                                                    {{ wage_type.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            wage_types: [
                {
                    name: '',
                    value: ''
                },{
                    name: this.$t('gateway.wage_types.percent'),
                    value: 'PERCENT'
                },
                {
                    name: this.$t('gateway.wage_types.fixed'),
                    value: 'FIXED'
                },
                {
                    name: this.$t('gateway.wage_types.periodic'),
                    value: 'PERIODIC',
                }
            ],
            query: {},
        }
    }
}
</script>